let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j87NQ"), load("joJy8"), load("aHE9G"), load("aoU9B")]).then(() => parcelRequire('a6OFr'));